import { Component, OnInit } from '@angular/core';
import { OidcSecurityService } from '../../auth/services/oidc.security.service';
import { ListWidgetContainerService } from './list-widget-container.service';
import { NotificationHandlerService } from '../notifications/notification-handler.service';

@Component({
    selector: 'list-widget-container',
    templateUrl: 'list-widget-container.component.html'
})

export class ListWidgetContainerComponent implements OnInit {

    public allWidgets: any;

    constructor(private _widgetService: ListWidgetContainerService,
        private _notificationService: NotificationHandlerService,
        public oidcSecurityService: OidcSecurityService) {

    }

    ngOnInit(): void {
        this.getData();
    }

    public getData() {
        this._widgetService
            .Get()
            .subscribe(data => {
                this.allWidgets = data
            },
            error => {
                this.oidcSecurityService.handleError(error),
                this._notificationService.handleError(error)
            },
            () => {});
    }
}



// WEBPACK FOOTER //
// ./angularApp/app/shared/list-widget-container/list-widget-container.component.ts